
export enum RouteBalancingTypeCd {
	AUTOSEQUENCE = 'Autosequence',
	MANUAL_SEQUENCE = 'ManualSequence',
	NO_ACTION = 'NoAction'}

